import * as React from 'react'
import { Box } from '@mui/system'
import {
  Modal,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: '35%',
  overflow: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  overFlow: 'auto',
  padding: '20px 20px 20px 20px'
}
const HeadBox = styled(Box)(() => ({
  '.btn-box': {
    display: 'flex',
    justifyContent: 'end'
  },
  '.customFormControl': {
    fontSize: '1px !important',
    fontWeight: '800'
  },
  '.customRadioGroup': {
    fontSize: '14px',
    fontWeight: '400',
    display: 'flex'
  },
  '.css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
    borderRadius: '32px !important'
  },
  '.validation-error': {
    color: 'red'
  },
  '.validation-errors': {
    color: 'red',
    paddingTop: '20px !important',
    fontSize: '12px !important'
  },
  '.jobcardform': {
    display: 'flex',
    justifyContent: 'end'
  },
  '.date-picker-fieldset': {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#8A8A8A'
      }
    },
    '.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px !important'
    },
    '.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px 12px !important'
    },
    '.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
      borderRadius: '4px !important'
    }
  },
  '.date-picker': {
    width: '100%',
    '.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '9.5px 12px'
    },
    '.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
      borderRadius: '4px'
    }
  },
  '.btn-text-transform': {
    textTransform: 'capitalize !important'
  }
}))

const InspectionDetailsView = (props) => {
  const { open, DetailsHandleClose, finalBompartData, selectedRow } = props
  const data = finalBompartData

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={DetailsHandleClose}
        aria-labelledby=""
        aria-describedby="modal-modal-description"
      >
        <HeadBox sx={style}>
          <Box className="title-head-box">
            <Typography className="top-up-name">Inspection Details</Typography>
            <CloseIcon className="close-icon" onClick={DetailsHandleClose} />
          </Box>
          <Grid item xs={12}>
            <Box>
              <Grid
                container
                spacing={2}
                paddingLeft={'25px'}
                paddingTop={'15px'}
                gap={'20px'}
              >
                {/* Row 1 */}
                <Grid item xs="auto" container>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Part Name:
                    </Typography>
                    <Typography className="span-color" fontWeight="bold">
                      {data?.partName || '-'}
                    </Typography>
                  </Box>
                </Grid>
                {/* Row 2 */}
                <Grid item xs="auto" container>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Department Name:
                    </Typography>
                    <Typography className="span-color" fontWeight="bold">
                    {selectedRow?.department?.name || '-'}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs="auto" container>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="subtitle2" color="textSecondary">
                      No. of Tasks:
                    </Typography>
                    <Typography className="span-color" fontWeight="bold">
                    {data?.bomprocess?.find(p => p?.department?.name === selectedRow?.department?.name)?.taskCount ?? '-'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid>
                <Box sx={{ padding: '10px', paddingTop: '25px ' }}>
                  <Box
                    sx={{
                      border: '1px solid #A9A6A6',
                      borderRadius: '12px 12px 0 0',
                      overflow: 'hidden'
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Task</TableCell>
                            <TableCell>Pass </TableCell>
                            <TableCell>Reject</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {finalBompartData?.bomprocess?.filter(process => process?.department?.name === selectedRow?.department?.name)?.map((row, partIndex) =>
                            row?.task?.map((task, taskIndex) => (
                                <TableRow
                                  key={`${partIndex}-${partIndex}-${taskIndex}`}
                                >
                                  <TableCell>{partIndex + 1}</TableCell>
                                  <TableCell>
                                    {task?.taskNickName || '-'}
                                  </TableCell>
                                  <TableCell>{task?.pass ?? '-'}</TableCell>
                                  <TableCell>{task?.reject ?? '-'}</TableCell>
                                </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </HeadBox>
      </Modal>
    </React.Fragment>
  )
}
export default InspectionDetailsView
